import { useRouter } from 'next/router';
import { signIn, useSession } from 'next-auth/react';

import { SearchMessage } from '@/components/modules/search/message';
import { getUpgradeAccountUrl } from '@/utils/helpers/urls';
import { trackUser } from '@/utils/tracking';

const SearchLimitMessage = () => {
  const router = useRouter();
  const { data: session } = useSession();

  const handleSignInClick = () => {
    signIn();
    trackUser.event('Go to: Sign-in', {
      location: 'Search Limit Message',
    });
  };

  const handleUpgradeAccountClick = () => {
    const url = getUpgradeAccountUrl();
    router.push(url);
    trackUser.event('Go to: Upgrade Account', {
      location: 'Search Limit Message',
    });
  };

  return session ? (
    <SearchMessage
      image="search-lock"
      heading="You have reached your monthly search limit"
      body="You'll have to wait until your monthly usage resets, or you can upgrade to a bigger plan to access more."
      buttonText="Manage plan"
      onClick={handleUpgradeAccountClick}
    />
  ) : (
    <SearchMessage
      image="search-lock"
      heading="You have reached your daily search limit"
      body="Sign in now to access more searches including carrier schedules and routes. It's free and only takes a few seconds."
      buttonText="Sign in now"
      onClick={handleSignInClick}
    />
  );
};

export { SearchLimitMessage };
